import { isNull } from 'utils/tsHelpers';
import { useModalContext } from 'utils/contexts/modal';
import { useSelectedHyperlink } from '../../hooks/useSelectedHyperlink';
import { useEditorContext } from '../../contexts/editor';

export const useDisableHyperlink = () => {
  const { editor } = useEditorContext();
  const { hideModal } = useModalContext();
  const selectedHyperlink = useSelectedHyperlink();

  return () => {
    if (!isNull(selectedHyperlink)) {
      const linkContents = selectedHyperlink.childNodes;
      linkContents?.forEach((childNode) => {
        selectedHyperlink.parentNode?.insertBefore(childNode, selectedHyperlink);
      });
      selectedHyperlink.remove();
      hideModal();
      editor?.focus();
    }
  };
};
